//Dependencies
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//Main Components
import Drawer from '../../../components/Drawer';
//Components
import Virtual01 from '../virtual/Virtual01';

const Drawer01 = (props) =>
{
  const { data, isMobile } = props; 
  const dispatch = useDispatch();

  const drawer01 = useSelector(state => state.drawers.drawer01);

  let message = 
  `_*CONSULTA*_

    %0aSaludos *${data.info.name}*, los encontré en *CONSTRUVISOR* 

    %0aAyúdeme con mas información
  `;

  const closeDrawer = () =>
  {
    const scroller = document.querySelector("#scroller");
    dispatch({type: 'SET_SELECTED', selected : null});
    scroller.scrollTo(0,0);

    dispatch({type: 'SET_DRAWER_01', drawer01 : false});

    dispatch({type: 'SET_TIMER', timer : false});
  };

  return(
    <Drawer
      height    = {isMobile ? 80 : 60}
      visible   = {drawer01}
      onClose   = {() => closeDrawer()}      
    >
      <div className = "w-full bg-white select-none">
        <div className = "flex bg-white">
          <div className = "flex items-center flex-col text-center px-6 lg:text-left lg:w-1/2 lg:min-h-[500px] md:px-12 md:w-full sm:w-full w-full" >
            <div className = "w-full">
              {data && 
                <h2 className = "text-xl font-bold text-gray-800 uppercase md:text-4xl mt-3 mb-1">
                  {data.info.name}
                </h2>
              }
              
              <div className = "w-full flex flex-row justify-center md:justify-start sm:mt-1 md:mt-3">
                <h3 className = "font-bold text-gray-800 uppercase  sm:text-base md:text-2xl">
                  {data.info.type}
                </h3>

                &nbsp; 
                <h3 className = "font-bold text-gray-800 uppercase  sm:text-base md:text-2xl">
                  -
                </h3>
                &nbsp; 

                <h3 className = "font-bold text-gray-800 uppercase italic sm:text-xl md:text-2xl">
                  {data.info.subtype}
                </h3>
              </div>
            </div>

            <div className = "w-full lg:m-10">
              {!isMobile &&
                <React.Fragment>                  
                  <div className = 'flex items-center justify-evenly my-6 w-full'>
                    {data.gps && data.gps.waze &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.waze.com/ul?ll=${data.location[0]},${data.location[1]}&navigate=yes`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'waze', isMobile)}
                        >
                          <i className = "fab fa-waze" ></i>
                        </a>
                      </div>
                    }

                    {data.gps && data.gps.google &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.google.com/maps/dir/?api=1&destination=${data.location[0]}%2C${data.location[1]}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'maps', isMobile)}
                        >
                          <i className = "fas fa-map-marked"></i>
                        </a>
                      </div>
                    }

                    {data.gps.gsv && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://goo.gl/maps/${data.gps.gsv}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'gsv', isMobile)}
                        >
                          <i className = "fas fa-street-view"></i>
                        </a>
                      </div>
                    }
                    
                    {data.links.whatsapp && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = { isMobile ? `whatsapp://send?phone=${data.links.whatsapp}&text=${message}` : `https://web.whatsapp.com/send?phone=${data.links.whatsapp}&text=${message}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'whatsapp', isMobile)}
                        >
                          <i className = "fab fa-whatsapp"></i>
                        </a>
                      </div>
                    }

                    {data.links.webpage && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {data.links.webpage}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'webpage', isMobile)}
                        >
                          <i className = "fas fa-globe"></i>
                        </a>
                      </div>
                    }
                  </div>

                  <div className = 'flex items-center justify-evenly my-6 w-full'>
                    {data.links.tiktok &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.tiktok.com/@${data.links.tiktok}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'waze', isMobile)}
                        >
                          <i className = "fab fa-tiktok" ></i>
                        </a>
                      </div>
                    }

                    {data.links.instagram &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.instagram.com/${data.links.instagram}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'maps', isMobile)}
                        >
                          <i className = "fab fa-instagram"></i>
                        </a>
                      </div>
                    }

                    {data.links.facebook &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.facebook.com/${data.links.facebook}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'gsv', isMobile)}
                        >
                          <i className = "fab fa-facebook"></i>
                        </a>
                      </div>
                    }                   
                  </div>
                </React.Fragment>
              }

              {isMobile &&
                <React.Fragment>
                {/* LOCATION */}
                  <div className = 'flex items-center justify-evenly my-6 w-full'>
                    {data.gps && data.gps.waze &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.waze.com/ul?ll=${data.location[0]},${data.location[1]}&navigate=yes`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'waze', isMobile)}
                        >
                          <i className = "fab fa-waze" ></i>
                        </a>
                      </div>
                    }

                    {data.gps && data.gps.google &&
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://www.google.com/maps/dir/?api=1&destination=${data.location[0]}%2C${data.location[1]}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'maps', isMobile)}
                        >
                          <i className = "fas fa-map-marked"></i>
                        </a>
                      </div>
                    }

                    {data.google && data.google.gsv && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {`https://goo.gl/maps/${data.google.gsv}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'gsv', isMobile)}
                        >
                          <i className = "fas fa-street-view"></i>
                        </a>
                      </div>
                    }                
                  </div>

                  {/* SOCIAL */}
                  <div className = 'flex items-center justify-evenly my-6 w-full'>
                    {data.project && data.project.whatsapp && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = { isMobile ? `whatsapp://send?phone=${data.project.whatsapp}&text=${message}` : `https://web.whatsapp.com/send?phone=${data.project.whatsapp}&text=${message}`}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'whatsapp', isMobile)}
                        >
                          <i className = "fab fa-whatsapp"></i>
                        </a>
                      </div>
                    }

                    {data.google && data.project.webpage && 
                      <div className = "lg:text-4xl md:text-3xl text-2xl text-center inline-flex items-center justify-center lg:w-16 lg:h-16 md:w-14 md:h-14 w-12 h-12 my-1 shadow-lg rounded-2xl bg-gray-900 cursor-pointer">
                        <a
                          className = "w-full h-full flex items-center justify-center rounded-2xl hover:bg-sky-600 text-gray-200 hover:text-gray-200 "
                          target = '_blank'
                          rel = "noopener noreferrer"
                          href = {data.project.webpage}
                          //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'webpage', isMobile)}
                        >
                          <i className = "fas fa-globe"></i>
                        </a>
                      </div>
                    }
                  </div>
                </React.Fragment>
              }

              {/* PORTAFOLIO */}
              <div className = 'flex items-center justify-center'>
                <a
                  target = '_blank'
                  rel = "noopener noreferrer"
                  href = {`${window.location.origin}/${data.info.username}`}
                  //onClick = {() => spotNotificacion(`${data.info.name.toUpperCase()} ${data.info.branch ?  `- ${data.info.branch.toUpperCase()}` : ''}`, 'menu', isMobile)}
                  className = "h-[40px] w-[300px] flex justify-center hover:text-white bg-transparent hover:bg-sky-500 text-gray-800 font-semibold border-2 border-gray-800 hover:border-transparent rounded my-1 cursor-pointer py-5"
                >
                  <h1 className = 'flex items-center m-0 text-2xl font-bold'>
                    PORTAFOLIO
                  </h1>
                </a>
              </div>

              <div className = "flex justify-center bg-white"  >
                <button
                    className = 'bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 border border-red-700 rounded lg:w-1/4 w-2/3 text-lg tracking-widest mb-2 mt-5'
                    onClick={() => 
                      {
                        closeDrawer();
                      }}
                  >
                    CERRAR
                  </button>
              </div>
            </div>
          </div>
          
          {!isMobile &&
            <div 
              className = "hidden lg:block lg:w-1/2"
              style   =
              {{
                clipPath : 'polygon(10% 0, 100% 0%, 100% 100%, 0 100%)'
              }}
            >
              {data.images.main &&
                <Virtual01
                  panoURL   = {data.images.main}
                  data      = {data}
                  isMobile  = {isMobile}
                />
              }
            </div>
          }
        </div>
      </div>
    </Drawer>
  );
}

export default Drawer01;